const Close = () => (
  <>
    <path
      fill="currentColor"
      d="m11.293 12-4.95-4.95a.48.48 0 0 1-.15-.353q0-.204.15-.354.152-.15.354-.15.203 0 .353.15l4.95 4.95 4.95-4.95q.15-.15.354-.15t.353.15q.15.152.15.354 0 .203-.15.353L12.707 12l4.95 4.95q.15.15.15.354t-.15.353-.354.15a.49.49 0 0 1-.353-.15L12 12.707l-4.95 4.95q-.15.15-.353.15a.49.49 0 0 1-.354-.15.48.48 0 0 1-.15-.354q0-.203.15-.353z"
    />
  </>
)
export default Close
